export default {"src":"/_next/static/media/camera-white-mobile.65439053.svg","height":17,"width":17};